import React from "react"

import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { useTranslation, Link } from "@zestia/gatsby-plugin-react-i18next"
import SanityGatsbyImage from "@/components/SanityGatsbyImage"
import GenericImage from "@/images/blog/generic-image.png"
import { gtmTracking } from "@/utils/gtm-tracking"

const BlogPostPreview = ({ post }) => {
  const { t } = useTranslation()

  return (
    <Link
      className={`blog-post-preview`}
      to={post.frontmatter.slug}
      onClick={() =>
        gtmTracking("Link Click", post.frontmatter.title, "Blog Post Preview")()
      }
    >
      <div className="blog-post-preview__image">
        {post.frontmatter.preview_image ? (
          post.internal.type === "SanityBlogPost" ? (
            <SanityGatsbyImage
              image={post.frontmatter.preview_image}
              maxWidth={300}
              alt={post.frontmatter.title}
            />
          ) : (
            <GatsbyImage
              image={getImage(post.frontmatter.preview_image.src)}
              alt={post.frontmatter.title}
            />
          )
        ) : (
          <img src={GenericImage} alt={post.frontmatter.title} />
        )}
      </div>

      {/* Content */}
      <div className="blog-post-preview__content">
        <h2 className="mb-0 h5">{post.frontmatter.title}</h2>
      </div>
    </Link>
  )
}

export default BlogPostPreview
